import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getServiceUrl } from '../../config';
import { Avatar, Card, Collapse, Spin, Alert, Button } from 'antd';
import { BiSolidCheckCircle, BiSolidXCircle } from 'react-icons/bi';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';

const API_BASE_URL = getServiceUrl();

const ChatBotResult = ({ params }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPatientData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('tokenId');
        const { data } = await axios.get(
          `${API_BASE_URL}patient/getpatientdata`,
          {
            headers: {
              rdxtoken: token,
              patientguid: params.patientguid,
            },
          },
        );
        setData(data);
        console.log(data);
      } catch (err) {
        console.error('Error fetching chatbot results!', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPatientData();
  }, [params.patientguid]);

  if (loading) {
    return (
      <div className="flex h-[80vh] items-center justify-center">
        <Spin tip="Loading Chatbot Results..." size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-[80vh] items-center justify-center">
        <Alert
          message="Error"
          description={error.message}
          type="error"
          showIcon
        />
      </div>
    );
  }

  // Assume the API returns an array and we're only interested in the first element.
  const patient = data?.[0];

  return (
    <div className="mx-auto h-[80vh] w-4/5 overflow-y-auto">
      {/* Patient card */}
      <Card title="Assessment" className="mb-3 w-full">
        <div className="flex gap-3">
          <Avatar
            shape="square"
            size={50}
            src={`https://ui-avatars.com/api/?name=${patient.firstname}+${patient.lastname}`}
          />
          <div>
            <Link to={`/patients/${params.patientguid}`}>
              <p className="font-semibold">{`${patient.firstname} ${patient.lastname}`}</p>
            </Link>
            <span className="text-sm text-gray-600">
              created on {patient.created_at}
            </span>
          </div>
        </div>
        <p className="mt-3">
          {patient.response_message === '✅ Assessment complete!' ? (
            <span>
              <BiSolidCheckCircle
                className="mx-1 inline text-green-600"
                size={25}
              />
              Assessment Completed
            </span>
          ) : (
            <span>
              <BiSolidXCircle className="mx-1 inline text-red-500" size={25} />
              Assessment Not Completed
            </span>
          )}
          <span
            className={clsx('mx-2 rounded-md p-2', {
              'bg-red-100 text-red-500': patient.risk_level === 'High Risk',
              'bg-yellow-100 text-yellow-500':
                patient.risk_level === 'Medium Risk',
              'bg-green-100 text-green-500': patient.risk_level === 'Low Risk',
            })}
          >
            {patient.risk_level}
          </span>
        </p>
      </Card>

      <Collapse className="mb-3">
        <Collapse.Panel header="Patient summary" key="1">
          <p className="font-semibold text-slate-800">{patient.summary}</p>
        </Collapse.Panel>
      </Collapse>

      {/* Continue to Patient Profile button */}
      <div className="mt-8 flex justify-center pb-8">
  <Button
    type="primary"
    size="small"
    onClick={() => navigate(`/patients/${params.patientguid}`)}
    className="
      flex items-center gap-2 
      bg-gradient-to-r from-green-400 to-green-500
      hover:from-green-500 hover:to-green-600
      border-none px-4 py-3 h-auto
      text-sm font-medium
      shadow-md hover:shadow-lg
      transform hover:-translate-y-0.5
      transition-all duration-200
    "
  >
    Continue to Patient Profile
    <span className="text-lg">&rarr;</span>
  </Button>
</div>

    </div>
  );
};

export default ChatBotResult;
